import styles from './CarrusellArrowLeft.module.css'
import {IoIosArrowBack} from 'react-icons/io'

export default function CarrusellArrowLeft(props){return(<div style={{height:`${props}px`}} className={styles.container}><IoIosArrowBack/></div>)}